import Login2 from './login-2.vue'
export default Login2